var render, staticRenderFns
import script from "./BaseItemCard.vue?vue&type=script&lang=ts&"
export * from "./BaseItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./BaseItemCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cbfcce4')) {
      api.createRecord('7cbfcce4', component.options)
    } else {
      api.reload('7cbfcce4', component.options)
    }
    
  }
}
component.options.__file = "src/components/BaseItemCard.vue"
export default component.exports